import { Dashboard } from "@/components";
import { Collection } from "@/components";

export const CollectionPage = () => (
  <Dashboard openLogIn>
    <Collection />
  </Dashboard>
)